<template>
  <analytics-sub-page
    :title="$t('analytics.app.title')"
    icon="mobile-screen-button"
    css-class="analytics-app"
    :default-label="$t('analytics.app.defaultLabel')"
    :section-specs="sectionSpecs"
  >
    <snapshot-metrics />
    <track-metrics ref="trackRef" />

    <!-- Build (Workplace Savings) -->
    <build-metrics v-if="isBuildEnabled" ref="buildRef" />
    <locked-metric-panel v-else-if="portalUpdatesJan2026Enabled" product-key="build" />

    <stream-metrics ref="streamRef" />

    <!-- Budget -->
    <budget-metrics v-if="isBudgetEnabled && portalUpdatesJan2026Enabled" ref="budgetRef" />
    <locked-metric-panel v-else-if="portalUpdatesJan2026Enabled" product-key="budget" />

    <!-- Rewards -->
    <rewards-metrics v-if="isRewardsEnabled && portalUpdatesJan2026Enabled" ref="rewardsRef" />
    <locked-metric-panel v-else-if="portalUpdatesJan2026Enabled" product-key="rewards" />

    <!-- SDL -->
    <sdl-metrics v-if="isSdlEnabled" ref="sdlRef" />
    <locked-metric-panel v-else-if="portalUpdatesJan2026Enabled" product-key="sdl" />

    <!-- Coach -->
    <coach-metrics v-if="isCoachEnabled && portalUpdatesJan2026Enabled" ref="coachRef" />
    <locked-metric-panel v-else-if="portalUpdatesJan2026Enabled" product-key="coach" />

    <coach-metrics-stub v-if="tescoPortalStubsEnabled" />
  </analytics-sub-page>
</template>

<script setup>
import { computed, ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import { getBankingInfo } from '@/Banking';
import BudgetMetrics from '@/pages/analyticsApp/components/BudgetMetrics.vue';
import BuildMetrics from '@/pages/analyticsApp/components/BuildMetrics.vue';
import CoachMetrics from '@/pages/analyticsApp/components/CoachMetrics.vue';
import CoachMetricsStub from '@/pages/analyticsApp/components/CoachMetricsStub.vue';
import LockedMetricPanel from '@/pages/analyticsApp/components/LockedMetricPanel.vue';
import RewardsMetrics from '@/pages/analyticsApp/components/RewardsMetrics.vue';
import SnapshotMetrics from '@/pages/analyticsApp/components/SnapshotMetrics.vue';
import StreamMetrics from '@/pages/analyticsApp/components/StreamMetrics.vue';
import TrackMetrics from '@/pages/analyticsApp/components/TrackMetrics.vue';
import SdlMetrics from '@/pages/analyticsApp/components/SdlMetrics.vue';
import useFeatureFlags from '@/composables/useFeatureFlags';
import useProductAvailability from '@/composables/useProductAvailability';
import i18n from '@/i18n';

const { portalUpdatesJan2026Enabled, tescoPortalStubsEnabled } = useFeatureFlags();
const { isCoachEnabled, isBudgetEnabled, isRewardsEnabled, isSdlEnabled, isBuildEnabled } = useProductAvailability();

const trackRef = ref(null);
const buildRef = ref(null);
const streamRef = ref(null);
const budgetRef = ref(null);
const rewardsRef = ref(null);
const sdlRef = ref(null);
const coachRef = ref(null);

const bankingInfo = computed(() => getBankingInfo());

// Pay/Savings/Loans reuse Banking.js's per-country product names.
const sectionSpecs = computed(() => [
  { key: 'track', label: i18n.t('analytics.app.sections.track'), ref: trackRef },
  { key: 'savings', label: bankingInfo.value.save.label, ref: buildRef },
  { key: 'pay', label: bankingInfo.value.stream.label, ref: streamRef },
  { key: 'budget', label: i18n.t('analytics.app.sections.budget'), ref: budgetRef },
  { key: 'rewards', label: 'Rewards', ref: rewardsRef },
  { key: 'loans', label: bankingInfo.value.sdl.label, ref: sdlRef },
  { key: 'coach', label: 'Coach', ref: coachRef },
]);
</script>
